import React, { useState, createRef, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Button, Form } from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login, logout } from "../../../context/actions/user";
import EmailBox from "../../common/FormsInput/EmailBox";
import PasswordBox from "../../common/FormsInput/PasswordBox";
import Head from "../Head";
import { toasterConfig } from "../../../utils/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

toast.configure();
const Login = () => {

  localStorage.removeItem("_expiredTime");
  const dispatch = useDispatch();
  const emailRef = createRef();
  const passRef = createRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isFocus, setFocus] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  var regex = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;

  const _handleKeypress = (e) => {
    submitForm();
  };

  const submitForm = () => {
    setDisabled(true);
    emailRef.current.props.onChange(email);
    passRef.current.props.onChange(password);
    if (!regex.test(password)) setFocus(true);
    if (password && password.length) setFocus(true);

    if (email === "" || password === "") {
      toast.dismiss();
      toast.error("Values should not be empty", toasterConfig);
      //toast.error("Invalid Credentials, Please try again", toasterConfig);
      setDisabled(false);
    } else if (email && password) {
      dispatch(
        login({ email: email.toLowerCase(), password: password }, (result) => {
          setDisabled(false);
        })
      );
    }
  };

  /**
   * @togglePassword method call to submit valid form
   */

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`login-blc m-auto signup-box`}>
      <Head heading="Welcome! Please sign in to continue." />
      <Form>
        {/* <TextBox type="email" id="email" placeHolder="Enter your email" label="Email address" /> */}
        <EmailBox
          name="email"
          id="email"
          placeholder="Enter your email"
          handleVal={(val) => setEmail(val)}
          ref={emailRef}
          handleKeypress={(e) => _handleKeypress(e)}
          label="Email Address"
        />

        <div className="password-cell position-relative">
          <PasswordBox
            name="New Password"
            id="password"
            placeholder="Enter your password"
            showPassword={showPassword}
            label="Password"
            labelLink
            handleVal={(val) => setPassword(val)}
            ref={passRef}
            handleKeypress={(e) => _handleKeypress(e)}
            isIcon
            togglePassword={togglePassword}
          />

          {/* <button type='button' className="btn btn-outline-primary" onClick={togglePassword}>
          { showPassword=== false? <FontAwesomeIcon icon={faEye} /> :<FontAwesomeIcon icon={faEyeSlash} /> }
                    </button> */}
        </div>
        <div className="btn-cell d-flex">
          <Button
            disabled={disabled}
            className="flex-fill"
            color="primary"
            onClick={() => submitForm()}
          >
            Sign In
          </Button>
        </div>
      </Form>
      {/* Dont have an Account? <Link to="/register" >Create an Account</Link><br /> */}
      <Link to="/forgot-password">Forgot Password?</Link>
    </div>
  );
};

export default Login;
